<template>
  <Page v-if="isMenuView"><exception-page type="404" :show-home-button="!isMenuView" /></Page>
  <exception-page v-else type="404" :show-home-button="!isMenuView" />
</template>

<script>
import ExceptionPage from '@/components/Exception'
import Page from '@/components/Page'

export default {
  components: {
    Page,
    ExceptionPage,
  },
  computed: {
    isMenuView() {
      return this.$route.path.startsWith('/m')
    },
  },
}
</script>

<style scoped></style>
